import React, { Suspense } from "react";

import { TThemeProvider } from "@repo/ui/component";
import { EnvironmentUtil } from "@repo/libs/utils";
import { ToolsStorage } from "@repo/libs/storage";
import { ToolsRedux } from "@repo/libs/redux";
import { ToolsLanguage } from "@repo/libs/language";
import { ToolsNavigate } from "@repo/ui/navigate";

// ############ Base ############
import ComponentBaseAbstract from './_base/c.base.abstract';


export default (
    ToolsLanguage.hookReactComponent(
        class ComponentIndex 
            extends ComponentBaseAbstract {
                thisSnackProvider = null;


                /**
                 * constructor
                 *
                 * @param {*} props
                 */
                constructor(props) {
                    super(props);

                    console.log("ComponentIndex : constructor : hostname > " , [
                        EnvironmentUtil.domainProtocal(),
                        EnvironmentUtil.domainHostWithPort()
                    ] );
                    console.log("ComponentIndex : constructor : ToolsNavigate > " ,ToolsNavigate );
                }


                /**
                 * render
                 * 
                 * @return {*}
                 */
                render() {

                    return (
                        <TThemeProvider 
                            content={
                                ToolsRedux
                                    .render(
                                        ToolsNavigate.render(
                                            [
                                                ToolsNavigate.createRoute(
                                                    { uri: "/" },
                                                    import("./screen/root/index"),
                                                    [
                                                        ToolsNavigate.createRoute(
                                                            { uri: "/home" },
                                                            import("./screen/home/index"),
                                                            []
                                                        ),
                                                                                                                                                                    
                                                        ToolsNavigate.createRoute(
                                                            { uri: "/about" },
                                                            import("./screen/about/index")
                                                        ),
                                                                             
                                                        ToolsNavigate.createRoute(
                                                            { uri: "/contact-us" },
                                                            import("./screen/contact/index")
                                                        ),

                                                        ToolsNavigate.createRoute(
                                                            { uri: "/pricing" },
                                                            import("./screen/pricing/index")
                                                        ),

                                                        ToolsNavigate.createRoute(
                                                            { uri: "/products" },
                                                            import("./screen/products/index")
                                                        ),
                                                                 
                                                        ToolsNavigate.createRoute(
                                                            { uri: "/sign-in" },
                                                            import("./screen/signin/index")
                                                        ),
                                                                                 
                                                        ToolsNavigate.createRoute(
                                                            { uri: "*" },
                                                            import("./screen/error/screen.error.page.not.exist")
                                                        )
                                                    ]
                                                ),
                                                                                    
                                                ToolsNavigate.createRoute(
                                                    { uri: "*" },
                                                    import("./screen/error/screen.error.page.not.exist")
                                                )
                                            ]
                                        )
                                    )
                            }
                        />
                    );

                }
            
            }
    )

);
